import React from 'react';

const experiences = [
  {
    title: 'DevOps Engineer',
    company: 'WareIQ Logistics Pvt Ltd',
    logo: '/logos/wareiq.png',
    duration: 'Jul 2025 – Present',
    description: 'Leading DevOps automation and multi-cloud infrastructure for logistics microservices on AWS and GCP.',
    points: [
      'Provisioned AWS EKS and GCP GKE clusters with Terraform, managing scalable environments across regions',
      'Built multi-tenant CI/CD pipelines using jenkins and Kubernetes namespaces',
      'Managed IAM roles, VPC networking, and fine-grained RBAC across staging and production',
      'Integrated Trivy, Snyk, and SonarQube for secure build and deployment pipelines',
      'Implemented full-stack observability with Loki, Prometheus, Grafana, and uptime alerts',
      'Collaborated with cross-functional teams to enable zero-downtime deployments for 1,000+ active users',
      'Optimized infrastructure provisioning and cost across AWS and GCP using automated scaling strategies',
    ],
  },
  {
    title: 'DevOps Engineer',
    company: 'Bizmagnets AI',
    logo: '/logos/bizmagnets.png',
    duration: 'Jun 2023 – Jul 2025',
    description: 'Delivered secure, cloud-native DevOps solutions hosted entirely on AWS for AI-enabled microservices.',
    points: [
      'Built and managed CI/CD pipelines using GitLab CI and Jenkins for 10+ services on AWS',
      'Provisioned AWS infrastructure (EKS, EC2, S3, IAM) using modular Terraform configurations',
      'Configured GitOps workflows with ArgoCD and Helm for Kubernetes-based deployments',
      'Integrated static/dynamic security scanning using SonarQube, Trivy, and Snyk',
      'Set up Prometheus, Loki, and Grafana for real-time log aggregation and visualization',
      'Collaborated with developers to enforce pipeline quality gates and automated rollbacks',
    ],
  },
  {
    title: 'DevOps Engineer',
    company: 'Vamosys',
    logo: '/logos/vamosys.png',
    duration: 'Jun 2023 – Jul 2025',
    description: 'Managed DigitalOcean-hosted infrastructure for a GPS tracking platform with 30,000+ connected vehicles.',
    points: [
      'Developed GitLab CI pipelines with auto-versioning, release tagging, and scheduled deployment',
      'Provisioned and managed Redis clusters with master-slave replication for high availability',
      'Configured automated MySQL backups, alerts, and secure database access policies',
      'Maintained 24x7 monitoring and alerting using Prometheus, Grafana, and custom rules',
      'Reduced query latency by 40% through optimized cache and DB architecture',
    ],
  },
  {
    title: 'DevOps Consultant',
    company: 'Athulya Senior Care (Client Company Project)',
    logo: '/logos/athulya.png',
    duration: 'Jan 2024 – Jul 2025',
    description: 'Modernized legacy services for a healthcare provider using cost-effective DigitalOcean infrastructure.',
    points: [
      'Migrated services from Hostinger to DigitalOcean droplets with hardened firewall configurations',
      'Deployed NGINX reverse proxies and implemented Let’s Encrypt SSL for frontend security',
      'Enabled secure backend access using OpenVPN and firewall rules for MySQL/web services',
      'Automated system monitoring using Monit with disk/memory alerting',
      'Scheduled daily backups and enforced access control for critical services',
    ],
  },
];

function Experience() {
  return (
    <section
      id="experience"
      className="bg-slate-900 text-white px-6 py-16 scroll-mt-28"
    >
      <h2 className="text-3xl font-bold mb-10 text-center">Experience</h2>

      <div className="space-y-8 max-w-5xl mx-auto">
        {experiences.map((exp, index) => (
          <div
            key={index}
            className="bg-slate-800 rounded-lg p-6 shadow-md flex flex-col sm:flex-row gap-6 items-start"
          >
            <img
              src={exp.logo}
              alt={`${exp.company} logo`}
              className="w-16 h-16 object-contain"
            />
            <div>
              <h3 className="text-xl font-bold text-blue-400">{exp.title}</h3>
              <p className="text-gray-300 font-medium">{exp.company}</p>
              <p className="text-sm text-gray-400 mb-2 italic">{exp.duration}</p>
              <p className="mb-2">{exp.description}</p>
              <ul className="list-disc list-inside text-gray-300 space-y-1">
                {exp.points.map((point, idx) => (
                  <li key={idx}>{point}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Experience;
